:host {
  display: flex;
  transform: scaleY(0);
  transform-origin: 100% 0;
  transition: transform 0.25s;
}

:host(.active) {
  transform: scaleY(1);
}